import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Template from './components/Template.jsx';
import animes from "./answers/animes.js"
import que from "./questions/generalQues.js";
import advAnime from './answers/adventureAns.js';
import adventureAnime from './questions/adventure.js'
import Navbar from './components/Navbar.jsx';
import Home from './components/Home.jsx';

import Privacy from './components/Privacy.jsx';
import Result from './components/Result.jsx';
const type = {
    rein:"What anime world you have reincarnated into ?",
    adv:"What adventure anime world is waiting for you ?"
}

const Routing = () =>{
    return (
        <Routes>
            <Route path='/' element={<Home/>} exact/>
            <Route path='/reincarnation' element={<Template head={type.rein} que={que} animes={animes} exact/>}/>
            <Route path='/adventure' element={<Template head={type.adv} que={adventureAnime} animes={advAnime} exact/>}/>
            <Route path='/privacy' element={<Privacy/>} exact/>
            <Route path='/result' element={<Result/>} exact/>
        </Routes>
    )
}

function App() {

    return (
        <div className="App">
            <BrowserRouter>
                <Navbar/>
                <Routing/>
                
            </BrowserRouter>
           </div>
    );
}

export default App;
